import Icon from '@material-ui/icons/Inbox';
import List from './SupplyInventoryList';

export default {
    list: List,
    icon: Icon,
};
